import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { CaretDown, Globe } from 'phosphor-react'
import { useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useTranslation } from '../../../../contexts/TranslationContext'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'

export const LanguageDropdown = () => {
  const { formatMessage } = useIntl()
  const [locale, setLocale] = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const dropdownRef = useRef(null)

  useOnClickOutside(dropdownRef, () => {
    setTimeout(() => {
      setIsOpen(false)
    }, 200)
  })

  return (
    <DropdownMenu.Root modal={false} open={isOpen} >
      <DropdownMenu.Trigger asChild ref={dropdownRef}>
        <button
          className="flex items-center gap-1 font-semibold uppercase outline-none"
          onClick={() => setIsOpen(true)}
        >
          <Globe size={20} />
          <CaretDown />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="flex flex-col pt-[30px] bg-[#001D2F] rounded-b-lg overflow-hidden">
          <button
            type="button"
            className="block py-2 px-2.5 font-semibold text-white text-left hover:bg-[#4A7D9A]"
            onClick={() => setLocale('en')}
          >
            {formatMessage({ id: 'ENGLISH' })}
          </button>
          <button
            type="button"
            className="block py-2 px-2.5 font-semibold text-white text-left hover:bg-[#4A7D9A]"
            onClick={() => setLocale('pt')}
          >
            {formatMessage({ id: 'PORTUGUESE' })}
          </button>
          <button
            type="button"
            className="block py-2 px-2.5 font-semibold text-white text-left hover:bg-[#4A7D9A]"
            onClick={() => setLocale('es')}
          >
            {formatMessage({ id: 'SPANISH' })}
          </button>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
